<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "App",
};
</script>

<style lang="scss" src="./_scss/_style.scss"></style>

<style>
html, body, #app {
  height: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
</style>
